var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHealth = function SvgIconHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M36.666 13.016v7.817h-6.8c-.2-.017-.633-.267-.733-.45L27.4 17.1c-.684-1.3-1.867-2.034-3.134-1.967s-2.35.917-2.9 2.3l-2.3 5.767-.333-.867c-.817-2.117-3.15-3.717-5.45-3.717l-9.95.05v-5.65c0-6.066 3.617-9.683 9.683-9.683h13.967c6.067 0 9.683 3.617 9.683 9.683"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M36.666 26.984v-3.65h-6.8c-1.116 0-2.433-.8-2.95-1.784l-1.733-3.283c-.467-.883-1.133-.833-1.5.083l-3.833 9.684c-.417 1.083-1.117 1.083-1.55 0l-1.9-4.8c-.45-1.167-1.85-2.117-3.1-2.117l-9.967.05v5.817c0 5.966 3.5 9.566 9.383 9.666.184.017.384.017.567.017h13.333c.25 0 .5 0 .734-.017 5.85-.133 9.316-3.716 9.316-9.666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#060E41",
    d: "M3.333 21.167v5.517c-.033-.534-.05-1.1-.05-1.684v-3.833z"
  })));
};
export default SvgIconHealth;